var $ = require('jquery');
var Storage = require('../common/storage');

function VeranstaltungsFilter() {
	return {
		inFutureOnly: 1,
		queryfield: 'name',
		queryvalue: '%',
		value: '',
		mandator: 'current',
		wildcard: 1,
		maxPerPage: 5,
		page: 1
	}
}

function VeranstaltungsListe() {

	var storageKey = 'zwe.einsatzplanung.filter';

	var controls = {
		inFutureOnly: $('input[name=inFutureOnly]'),
		queryvalue: $('input[name=queryvalue]'),
		wildcard: $('input[name=wildcard]'),
		mandator: $('input[name=mandator]:radio'),
		maxPerPage: $('select[name=maxPerPage]'),
		reset: $('#filter_reset'),
	};

	var selectors = {
		container: '#event_container',
		indicator: '#progress-event-list'
	};

	var filter = getOrCreateFilter();

	function newFilter() {
		return new VeranstaltungsFilter();
	}

	function getOrCreateFilter() {
		var filter = Storage.getPreferred().getItem(storageKey);
		if (!filter) {
			filter = newFilter();
		}
		return filter;
	}

	function saveFilterAndLoad() {
		saveFilter();
		load();
	}

	function saveFilter() {
		Storage.getPreferred().setItem(storageKey, filter);
	}

	function applyFilter() {
		controls.inFutureOnly.filter('[value=' + filter.inFutureOnly + ']').prop('checked', true);
		controls.queryvalue.val(filter.value);
		if (filter.wildcard > 0) {
			controls.wildcard.prop('checked', true);
		}
		else {
			controls.wildcard.prop('checked', false);
		}
		controls.mandator.prop('checked', false);
		controls.mandator.filter('[value=' + filter.mandator + ']').prop('checked', true);
		controls.maxPerPage.val(filter.maxPerPage);
	}

	function load() {
		if (filter.value && filter.value.length > 0) {
			filter.queryvalue = filter.value.replace(/\*/g, '%');
			if (controls.wildcard.filter(':checked').val() > 0) {
				filter.queryvalue = '%' + filter.value + '%';
			}
		}
		else {
			filter.queryvalue = '%';
		}
		$(selectors.indicator).removeClass('hidden');
		$.get(
			'ajax_events',
			{filter: JSON.stringify(filter)},
			function (data) {
				$(selectors.indicator).addClass('hidden');
				$(selectors.container).html(data);
			},
			'html'
		);
	}

	controls.inFutureOnly.click(function () {
		filter.inFutureOnly = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.queryvalue.change(function () {
		filter.value = $(this).val();
		saveFilterAndLoad();
	});
	controls.wildcard.click(function () {
		filter.wildcard = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.mandator.click(function () {
		filter.mandator = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.maxPerPage.change(function () {
		filter.maxPerPage = $(this).val();
		saveFilterAndLoad();
	});
	controls.reset.click(function (e) {
		filter = newFilter();
		applyFilter();
		saveFilterAndLoad();
		e.preventDefault();
		return false;
	});

	$(document).on('click', 'input[name^="ids"]', function () {
		if ($('input[name^="ids"]:checked').size() > 0) {
			$('#export').attr('disabled', false);
		} else {
			$('#export').attr('disabled', true);
		}
	});

	$(document).on('click', '#export', function () {
		$('#zwe-export').submit();
	});

	applyFilter();
	load();

	return {
		go: function (page) {
			filter.page = page;
			saveFilterAndLoad();
		},

		next: function () {
			filter.page++;
			saveFilterAndLoad();
		},

		previous: function () {
			filter.page--;
			saveFilterAndLoad();
		},

		sort: function (field) {
			if (filter.sortname == field) {
				this.switchSortOrder();
			}
			filter.sortname = field;
			saveFilterAndLoad();
		},

		switchSortOrder: function () {
			if (filter.sortorder == 'ASC') {
				filter.sortorder = 'DESC';
			}
			else {
				filter.sortorder = 'ASC';
			}
		}
	}
}

module.exports = VeranstaltungsListe;
